export default "__VITE_ASSET__39838831__"